import { FC } from 'react';

const BenefitTickIcon: FC = () => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91982 14.6983L0.913086 8.53064L2.68019 6.71621L6.91982 11.0694L17.407 0.30127L19.174 2.11571L6.91982 14.6983Z"
        fill="#BAA57E"
      />
    </svg>
  );
};

export default BenefitTickIcon;
